module.exports = __webpack_public_path__ + "staticV3/img/b90ea7e4.failure.png";